let active;

try {
  if (window.location.host.match(/pbrally/))
    active = true;
} catch(e) { }

export default {
  init: () => {
    if (active) {
    }
  },
  track: e => {
    try {
    }
    catch (e) {

    }
  }
}